import clsx from "clsx";
import React, { FunctionComponent } from "react";

import { useLanguage } from "../../../i18n/useLanguage";
import { useBodyClass } from "../../../util/useBodyClass";
import "./LandingPage.css";

const en = {
  blocks: [
    {
      description:
        "In a few easy steps, you can build your deal for the perfect vehicle and finalize purchase with your dealer.",
      image: "/static/img/mercedes_v2/landing-page/time.jpg",
      title: "Save Time and Shop Online",
    },
    {
      description:
        "Discover the full potential of your new Mercedes-Benz vehicle.",
      image: "/static/img/mercedes_v2/landing-page/online.jpg",
      title: "Go Online with Mercedes me",
    },
    {
      description:
        "Speed, power, and precision – these are the results of a dedication to driving performance.	",
      image: "/static/img/mercedes_v2/landing-page/amg.jpg",
      title: "Mercedes-AMG",
    },
  ],
  discover: "Discover Mercedes-Benz",
  futureVehicles: "FUTURE VEHICLES",
  hero: {
    description: "The new 2024 Mercedes-AMG CLE Coupe",
    footer: "The new shape of performance.",
    title: "INTRODUCING",
  },
  inTheSpotlight: "IN THE SPOTLIGHT",
  upcomingReleases: "Upcoming Releases",
};

const fr: typeof en = {
  blocks: [
    {
      description:
        "En quelques étapes faciles, vous pouvez construire votre offre pour le véhicule parfait et finaliser l'achat avec votre concessionnaire.",
      image: "/static/img/mercedes_v2/landing-page/time.jpg",
      title: "Gagnez du temps et magasinez en ligne",
    },
    {
      description:
        "Découvrez tout le potentiel de votre nouveau véhicule Mercedes-Benz.",
      image: "/static/img/mercedes_v2/landing-page/online.jpg",
      title: "Passez en ligne avec Mercedes me",
    },
    {
      description:
        "Vitesse, puissance et précision – ce sont les résultats d'un dévouement à la performance de conduite.",
      image: "/static/img/mercedes_v2/landing-page/amg.jpg",
      title: "Mercedes-AMG",
    },
  ],
  discover: "Découvrez Mercedes-Benz",
  futureVehicles: "VÉHICULES FUTURS",
  hero: {
    description: "La nouvelle Mercedes-AMG CLE Coupé 2024",
    footer: "La nouvelle forme de la performance.",
    title: "PRÉSENTATION",
  },
  inTheSpotlight: "SOUS LES PROJECTEURS",
  upcomingReleases: "Prochaines sorties",
};

export const LandingPage: FunctionComponent = () => {
  const [language] = useLanguage();
  const t = language === "fr" ? fr : en;
  useBodyClass("landing-page");
  return (
    <div className="container mx-auto px-4 pb-8 md:pb-16">
      <section>
        <header className="mb-lp-header">
          <h2>{t.futureVehicles}</h2>
          <h1>{t.upcomingReleases}</h1>
        </header>
        <figure className="grid md:grid-cols-12">
          <img
            alt={t.hero.description}
            className="md:col-span-7"
            src="/static/img/mercedes_v2/landing-page/intro.jpg"
          />
          <figcaption className="md:col-span-5 flex flex-col justify-center text-center p-4 gap-2 md:gap-6 md:-mt-16">
            <div className="text-sm font-thin md:text-lg">{t.hero.title}</div>
            <div className="font-serif text-xl md:text-4xl max-w-[8em] mx-auto">
              {t.hero.description}
            </div>
            <div className="text-sm md:text-lg">{t.hero.footer}</div>
          </figcaption>
        </figure>
      </section>
      <section className="mx-auto max-w-7xl">
        <header className="mb-lp-header">
          <h2>{t.inTheSpotlight}</h2>
          <h1>{t.discover}</h1>
        </header>
        <div className="mb-lp-blocks">
          {t.blocks.map(({ description, image, title }, key) => (
            <figure
              className={clsx(
                "mb-lp-figure",
                key == 0 && "mb-lp-figure--first"
              )}
              key={title}
            >
              <img alt={title} src={image} />
              <figcaption>
                <h2>
                  <strong>0{key + 1}</strong>
                  {title}
                </h2>
                <p>{description}</p>
              </figcaption>
            </figure>
          ))}
        </div>
      </section>
    </div>
  );
};
